import { render } from "./np-phone.vue?vue&type=template&id=38554f4a"
import script from "./np-phone.vue?vue&type=script&lang=js"
export * from "./np-phone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__